import usePlanningStore from '../planning';

export function setSnapBoundaries(target) {
  const { planning } = usePlanningStore();
  const boundaries = {};
  const laneXOffset = target.dragData.laneXOffset || 0;
  if (planning.visibleTimeline?.show_timegrid) { // snap to grid
    let xposition = laneXOffset; // starting point is laneXOffset to compare with pageX²
    planning.visibleTimeline.timelinecols.forEach((col) => {
      boundaries[xposition] = 'both';
      xposition += col.width;
    });
    boundaries[xposition] = 'left';
    xposition = laneXOffset;
    planning.visibleTimeline.subtimelinecols.forEach((col) => {
      boundaries[xposition] = 'both';
      xposition += col.width;
    });
    boundaries[xposition] = 'left';
  } else { // snap to elements
    planning.elements.forEach((el) => {
      if (el.isType('milestone')) return;
      if (el.id == target.dragData.id) return;
      const startposition = laneXOffset + el.xposition;
      if (boundaries[startposition] == 'right' || boundaries[startposition] == 'both') {
        boundaries[startposition] = 'both';
      } else {
        boundaries[startposition] = 'left';
      }
      const endposition = startposition + el.getWidth();
      if (boundaries[endposition] == 'left' || boundaries[endposition] == 'both') {
        boundaries[endposition] = 'both';
      } else {
        boundaries[endposition] = 'right';
      }
    });
  }

  target.dragData.uiSnap = {
    boundaries,
  };
}

export function snapToBoundaries(target) {
  const spacing = 2;
  const snapdata = target.dragData.uiSnap;
  if (! snapdata) return;
  const cursorOffsetX = target.dragData.cursorOffset?.x || 0;
  const left = target.dragData.position.left - cursorOffsetX;
  const width = target.dragData.cloneDimensions?.width || target.dragData.currentWidth;
  const pos = { left, right: left + width };

  const limits = Object.keys(snapdata.boundaries).map(limit => +limit);
  const [closestLeftBoundary] = limits.reduce((acc, limit) => {
    const distance = Math.abs(limit - pos.left);
    if (distance < 5) acc.push({ limit, distance, border: snapdata.boundaries[limit] });
    return acc;
  }, []).sort((a, b) => (a.distance < b.distance ? -1 : 1));
  const [closestRightBoundary] = limits.reduce((acc, limit) => {
    const distance = Math.abs(limit - pos.right);
    if (distance < 5) acc.push({ limit, distance, border: snapdata.boundaries[limit] });
    return acc;
  }, []).sort((a, b) => (a.distance < b.distance ? -1 : 1));
  if (! closestLeftBoundary && ! closestRightBoundary) return;

  if (target.dragData.handle) {
    if (target.dragData.handle == 'w' && closestLeftBoundary) {
      target.dragData.currentWidth -= closestLeftBoundary.limit - pos.left + (['right', 'both'].includes(closestLeftBoundary.border) ? spacing : 0);
    } else if (target.dragData.handle == 'e' && closestRightBoundary) {
      target.dragData.currentWidth = closestRightBoundary.limit - pos.left + (['left', 'both'].includes(closestRightBoundary.border) ? -spacing : 0);
    }
  } else if (closestLeftBoundary) {
    target.dragData.position.left = closestLeftBoundary.limit + (['right', 'both'].includes(closestLeftBoundary.border) ? spacing : 0);
    target.dragData.position.left += cursorOffsetX;
  } else if (closestRightBoundary) {
    target.dragData.position.left = closestRightBoundary.limit - width + (['left', 'both'].includes(closestRightBoundary.border) ? -spacing : 0);
    target.dragData.position.left += cursorOffsetX;
  }
}
